module.exports = __webpack_public_path__ + "img/round1.ec72a6ae.png";